<template lang="html">
  <div
    class="search-empty-panel flex min-h-0 flex-1 flex-col gap-5 sm:grid sm:grid-cols-[minmax(11rem,0.75fr)_minmax(0,1.85fr)] sm:items-stretch sm:gap-0"
  >
    <!-- Left: history -->
    <div
      class="search-empty-panel__history min-w-0 sm:me-5 sm:border-e sm:border-default sm:pe-5"
    >
      <div class="mb-2 flex items-center justify-between gap-2">
        <p class="text-xs font-semibold tracking-wide text-muted uppercase">
          История
        </p>
        <UButton
          v-if="historyItems.length"
          variant="link"
          color="neutral"
          size="xs"
          class="font-normal text-muted"
          @click="emit('clear-history')"
        >
          Очистить
        </UButton>
      </div>

      <ul
        v-if="historyItems.length"
        class="flex flex-col gap-0.5"
      >
        <li
          v-for="entry in historyItems"
          :key="entry"
        >
          <UButton
            variant="ghost"
            color="neutral"
            class="w-full justify-start gap-2 px-2 py-2 text-left font-normal"
            @click="emit('select-history', entry)"
          >
            <UIcon
              name="i-lucide-history"
              class="size-4 shrink-0 text-muted"
            />
            <span class="min-w-0 truncate">
              {{ entry }}
            </span>
          </UButton>
        </li>
      </ul>

      <p
        v-else
        class="px-2 py-3 text-sm text-muted"
      >
        Пока пусто
      </p>
    </div>

    <!-- Right: recommendations -->
    <div class="search-empty-panel__recs flex min-w-0 flex-col gap-3">
      <p class="text-xs font-semibold tracking-wide text-muted uppercase">
        Рекомендации
      </p>

      <div
        v-if="pending"
        class="space-y-2 py-1"
        aria-busy="true"
        aria-live="polite"
      >
        <div class="grid grid-cols-2 gap-2 sm:grid-cols-3 lg:grid-cols-3">
          <USkeleton
            v-for="n in REC_LIMIT"
            :key="`rec-skel-${n}`"
            class="aspect-square w-full"
          />
        </div>
      </div>

      <div
        v-else-if="products.length"
        class="grid grid-cols-2 gap-2 sm:grid-cols-3 sm:gap-3"
      >
        <ProductCard
          v-for="(product, index) in products"
          :key="product.id"
          mode="minimal"
          :value="product"
          :eager="index < 3"
          @click="emit('select')"
        />
      </div>

      <p
        v-else
        class="px-2 py-3 text-sm text-muted"
      >
        Нет рекомендаций
      </p>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ProductListItemDto } from '@repo/api/web/models'
import type { ProductsListGetRequestQuery } from '@repo/api/web/models'

import ProductCard from '#Products/components/Card/ProductCard.vue'

/** Temporary “recommendations”: catalog slice without Query (grill Q3.A). */
const REC_LIMIT = 12

defineProps<{
  historyItems: readonly string[]
}>()

const emit = defineEmits<{
  select: []
  'select-history': [query: string]
  'clear-history': []
}>()

const { service } = useProducts()

const { data, pending } = await useAsyncData(
  'search-empty-recommendations',
  () =>
    service.list({
      Limit: REC_LIMIT,
    } as ProductsListGetRequestQuery),
  {
    server: false,
  },
)

const products = computed(() =>
  ProductListItemDto.createFromCollection(data.value?.items ?? []),
)
</script>
